import { Box, Chip } from '@leap4/frontend';
import { ReportType } from '../reporting/reports';
import type { IReportingMetadata } from '../reporting/hooks/useReportingMetadata';

const REPORT_TYPE_CHIP: Record<ReportType, { label: string; color: 'info' | 'success' }> = {
  impression: { label: 'Impression Date', color: 'info' },
  conversion: { label: 'Conversion Date', color: 'success' },
};

export const buildReportTypeIndex = (metadata: IReportingMetadata): Map<string, ReportType[]> => {
  const index = new Map<string, ReportType[]>();
  for (const metric of metadata.metrics) {
    index.set(metric.key, (metric.reports ?? []) as ReportType[]);
  }
  for (const dimension of metadata.dimensions) {
    if (!index.has(dimension.key)) {
      index.set(dimension.key, (dimension.reports ?? []) as ReportType[]);
    }
  }
  return index;
};

export const renderReportTypeChips = (types: ReportType[]) =>
  types.length === 0 ? null : (
    <Box component="span" sx={{ display: 'inline-flex', gap: 0.5, ml: 1, flexShrink: 0 }}>
      {types.map((rt) => (
        <Chip
          key={rt}
          size="small"
          variant="outlined"
          label={REPORT_TYPE_CHIP[rt].label}
          color={REPORT_TYPE_CHIP[rt].color}
          sx={{ height: 18, fontSize: '0.62rem', '& .MuiChip-label': { px: 0.75 } }}
        />
      ))}
    </Box>
  );
